import { gql } from 'graphql-request'

const getArticle = gql`
  query getArticle($slug: String, $lang: [Locale!]!, $assetLocales: [Locale!]) {
    articles(where: { slug: $slug }, locales: $lang) {
      id
      title
      updatedAt
      slug
      isHearingStory
      isHearingSolutions
      excerpt
      seo {
        metaTitle
        metaDescription
        ogImage(locales: $assetLocales) {
          src: url(
            transformation: {
              image: { resize: { width: 1200, height: 630, fit: crop } }
            }
          )
        }
        noIndex
      }
      content {
        html
        text
        references {
          ... on Asset {
            id
            src: url(
              transformation: { image: { resize: { width: 752, fit: max } } }
            )
            src_webp: url(
              transformation: {
                image: { resize: { width: 752, fit: max } }
                document: { output: { format: webp } }
              }
            )
            src_large: url(
              transformation: { image: { resize: { width: 1270, fit: max } } }
            )
            src_large_webp: url(
              transformation: {
                image: { resize: { width: 1270, fit: max } }
                document: { output: { format: webp } }
              }
            )
            caption
            alt
            width
            height
            locale
          }
          ... on CallToAction {
            id
            title
            text
            type
            button
            link {
              ... on Link {
                url
              }
            }
          }
          ... on Gallery {
            id
            images(locales: $assetLocales) {
              src: url(
                transformation: {
                  image: { resize: { width: 370, height: 280, fit: crop } }
                }
              )
              src_large: url(
                transformation: {
                  image: { resize: { width: 600, height: 400, fit: crop } }
                }
              )
              src_webp: url(
                transformation: {
                  image: { resize: { width: 370, height: 280, fit: crop } }
                  document: { output: { format: webp } }
                }
              )
              src_large_webp: url(
                transformation: {
                  image: { resize: { width: 600, height: 400, fit: crop } }
                  document: { output: { format: webp } }
                }
              )
              alt
              caption
              locale
            }
          }
          ... on Quote {
            id
            quote
            author
          }
          ... on FirstParagraph {
            id
            content: text
          }
          ... on ListStepsCarousel {
            id
            listStepsCarouselItems {
              text
            }
          }
        }
      }
      author {
        ... on Author {
          title: name
          text: description
          image {
            url(transformation: { document: { output: { format: webp } } })
          }
        }
        ... on Mentor {
          title: firstName
          text: shortDescription
          about: aboutMentor
        }
      }
      tags {
        id
        title
      }
      topics {
        title
        slug
      }
      additionalTopic {
        title
        slug
      }
      subTopic {
        slug
        title
      }
      localizations(includeCurrent: true) {
        slug
        locale
      }
      image(locales: $assetLocales) {
        src: url(
          transformation: {
            image: { resize: { width: 1220, height: 500, fit: crop } }
            document: { output: { format: webp } }
          }
        )
        og: url(
          transformation: {
            image: { resize: { width: 1200, height: 630, fit: crop } }
          }
        )
        alt
        locale
      }
      imageMobile(locales: $assetLocales) {
        src: url(
          transformation: {
            image: { resize: { width: 1220, height: 500, fit: crop } }
            document: { output: { format: webp } }
          }
        )
        og: url(
          transformation: {
            image: { resize: { width: 1200, height: 630, fit: crop } }
          }
        )
        alt
        locale
      }
      hideListOfTopics
      nextArticle {
        title
        slug
        excerpt
        image {
          url(transformation: { document: { output: { format: webp } } })
        }
        topics {
          slug
          title
        }
        additionalTopic {
          slug
          title
        }
        subTopic {
          slug
          title
        }
      }
      parentPage {
        slug
        title
      }
    }
    relatedArticles: articles(
      where: { tags_some: { articles_some: { slug: $slug } }, slug_not: $slug }
      locales: $lang
    ) {
      id
      url: slug
      title
      text: content {
        text
      }
      topics {
        id
        slug
      }
      isHearingStory
      image(locales: $assetLocales) {
        src: url(
          transformation: {
            image: { resize: { width: 140, height: 140, fit: crop } }
          }
        )
        src_webp: url(
          transformation: {
            image: { resize: { width: 140, height: 140, fit: crop } }
            document: { output: { format: webp } }
          }
        )
        alt
      }
    }
    cta: pageCallToActions(
      where: { tags_some: { articles_some: { slug: $slug } } }
      locales: $lang
    ) {
      id
      title
      text
      smallText
      type: __typename
      buttonText {
        text
      }
      button: link {
        ... on Link {
          url
        }
      }
      visibility
    }
    topics: articleTopics(locales: $lang) {
      title
      subline
      text
      link: slug
      image(locales: $assetLocales) {
        src: url(
          transformation: {
            image: { resize: { width: 300, height: 225, fit: crop } }
            document: { output: { format: webp } }
          }
        )
        locale
      }
    }
    pageAnyQuestion(where: { id: "cm3efjo1mphb008uo14hcxlk3" }, locales: en) {
      type: __typename
      buttons {
        linkTarget
        title
        url
      }
      content {
        title
        text {
          text
        }
        image {
          url(transformation: { document: { output: { format: webp } } })
        }
      }
      label
      mentorsProfile {
        url(transformation: { document: { output: { format: webp } } })
      }
    }
  }
`
export default getArticle
